import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { take } from "rxjs";
import { RootState } from "../ngrx/root.model";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  let newRequest = request.clone();
  const store: Store<RootState> = inject(Store);

  store.pipe(take(1)).subscribe((state: RootState) => {
    if (state.app.userLoggedIn) {
      newRequest = newRequest.clone({
        headers: request.headers.set("Authorization", `Bearer ${state.app.userAuthData?.access_token ?? ""}`),
      });
    }
  });

  return next(newRequest);
};
